// extracted by mini-css-extract-plugin
export default {"mainWrap":"ReturnPolicyPage_mainWrap__Diycj cobe-globals_mainWrap__qu6Pq","container":"ReturnPolicyPage_container__zx9s4","pageTitle":"ReturnPolicyPage_pageTitle__AVz5U"};